import React from 'react'
import { withIcon } from '../../withIcon'

function LockedIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 3.625C11.1049 3.625 10.2464 3.98058 9.61351 4.61351C8.98058 5.24645 8.625 6.10489 8.625 7V10.375H15.375V7C15.375 6.10489 15.0194 5.24645 14.3865 4.61351C13.7536 3.98058 12.8951 3.625 12 3.625ZM16.625 10.375V7C16.625 5.77337 16.1377 4.59699 15.2704 3.72963C14.403 2.86228 13.2266 2.375 12 2.375C10.7734 2.375 9.59699 2.86228 8.72963 3.72963C7.86228 4.59699 7.375 5.77337 7.375 7V10.375H7C5.55025 10.375 4.375 11.5503 4.375 13V19C4.375 20.4497 5.55025 21.625 7 21.625H17C18.4497 21.625 19.625 20.4497 19.625 19V13C19.625 11.5503 18.4497 10.375 17 10.375H16.625ZM7 11.625C6.24061 11.625 5.625 12.2406 5.625 13V19C5.625 19.7594 6.24061 20.375 7 20.375H17C17.7594 20.375 18.375 19.7594 18.375 19V13C18.375 12.2406 17.7594 11.625 17 11.625H7ZM12 15.625C11.7929 15.625 11.625 15.7929 11.625 16C11.625 16.2071 11.7929 16.375 12 16.375C12.2071 16.375 12.375 16.2071 12.375 16C12.375 15.7929 12.2071 15.625 12 15.625ZM10.375 16C10.375 15.1025 11.1025 14.375 12 14.375C12.8975 14.375 13.625 15.1025 13.625 16C13.625 16.8975 12.8975 17.625 12 17.625C11.1025 17.625 10.375 16.8975 10.375 16Z" fill={color}/>
    </svg>
  )
}

export default withIcon(LockedIcon)
